(function (global) {
  'use strict';

  var configNode = global.document && global.document.getElementById('FiAklaDeliveryConfig');
  var config = global.fiAklaDeliveryConfig || {};
  if (configNode) {
    try { config = JSON.parse(configNode.textContent); } catch (error) {
      console.error('[Fi Akla] Invalid delivery configuration.', error);
    }
  }

  var timezone = config.timezone || 'Africa/Cairo';
  var locale = config.locale || 'en';
  var rules = Array.isArray(config.deliveryDays) ? config.deliveryDays : [];
  var weeklyRollover = config.weeklyRollover || null;
  var strings = config.strings || {};
  var exceptions = [];
  try {
    exceptions = JSON.parse(config.exceptionsJson || '[]');
    if (!Array.isArray(exceptions)) throw new Error('Exceptions must be an array.');
  } catch (error) {
    console.error('[Fi Akla] Invalid delivery exceptions JSON.', error);
    exceptions = [];
  }

  function pad(value) { return String(value).padStart(2, '0'); }

  function partsAt(epochMs) {
    var parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: timezone,
      year: 'numeric', month: 'numeric', day: 'numeric',
      hour: 'numeric', minute: 'numeric', second: 'numeric',
      hour12: false, hourCycle: 'h23'
    }).formatToParts(new Date(epochMs));
    var out = {};
    parts.forEach(function (part) {
      if (part.type !== 'literal') out[part.type] = parseInt(part.value, 10);
    });
    out.weekday = new Date(Date.UTC(out.year, out.month - 1, out.day)).getUTCDay();
    return out;
  }

  function timezoneOffset(epochMs) {
    var p = partsAt(epochMs);
    return Date.UTC(p.year, p.month - 1, p.day, p.hour, p.minute, p.second) - epochMs;
  }

  function localToEpoch(year, month, day, hour, minute) {
    var utcGuess = Date.UTC(year, month - 1, day, hour, minute, 0);
    var first = utcGuess - timezoneOffset(utcGuess);
    return utcGuess - timezoneOffset(first);
  }

  function datePartsFromISO(iso) {
    var values = iso.split('-').map(Number);
    return { year: values[0], month: values[1], day: values[2] };
  }

  function isoFromUTCDate(date) {
    return date.getUTCFullYear() + '-' + pad(date.getUTCMonth() + 1) + '-' + pad(date.getUTCDate());
  }

  function shiftISO(iso, days) {
    var p = datePartsFromISO(iso);
    var date = new Date(Date.UTC(p.year, p.month - 1, p.day));
    date.setUTCDate(date.getUTCDate() + days);
    return isoFromUTCDate(date);
  }

  function exceptionFor(iso) {
    return exceptions.find(function (item) { return item && item.date === iso; }) || null;
  }

  function ruleForWeekday(weekday) {
    return rules.find(function (item) { return item.weekday === weekday; }) || null;
  }

  function cutoffEpoch(iso, rule, exception) {
    if (exception && exception.cutoffAt) {
      var match = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})$/.exec(exception.cutoffAt);
      if (match) return localToEpoch(+match[1], +match[2], +match[3], +match[4], +match[5]);
    }
    var cutoffISO = shiftISO(iso, -(rule.cutoffOffsetDays || 1));
    var date = datePartsFromISO(cutoffISO);
    var time = (rule.cutoffTime || '12:00').split(':').map(Number);
    return localToEpoch(date.year, date.month, date.day, time[0], time[1]);
  }

  function weeklyCycleAt(nowEpoch) {
    if (!weeklyRollover || typeof weeklyRollover.weekday !== 'number') return null;

    var now = partsAt(nowEpoch);
    var rolloverWeekday = weeklyRollover.weekday;
    var daysSinceRollover = (now.weekday - rolloverWeekday + 7) % 7;
    var localToday = new Date(Date.UTC(now.year, now.month - 1, now.day));
    localToday.setUTCDate(localToday.getUTCDate() - daysSinceRollover);

    var rolloverISO = isoFromUTCDate(localToday);
    var rolloverDate = datePartsFromISO(rolloverISO);
    var rolloverTime = (weeklyRollover.time || '21:00').split(':').map(Number);
    var rolloverEpoch = localToEpoch(
      rolloverDate.year,
      rolloverDate.month,
      rolloverDate.day,
      rolloverTime[0],
      rolloverTime[1]
    );

    if (nowEpoch < rolloverEpoch) {
      rolloverISO = shiftISO(rolloverISO, -7);
      rolloverDate = datePartsFromISO(rolloverISO);
      rolloverEpoch = localToEpoch(
        rolloverDate.year,
        rolloverDate.month,
        rolloverDate.day,
        rolloverTime[0],
        rolloverTime[1]
      );
    }

    var nextRolloverISO = shiftISO(rolloverISO, 7);
    var nextRolloverDate = datePartsFromISO(nextRolloverISO);

    return {
      startISO: rolloverISO,
      startEpoch: rolloverEpoch,
      nextEpoch: localToEpoch(
        nextRolloverDate.year,
        nextRolloverDate.month,
        nextRolloverDate.day,
        rolloverTime[0],
        rolloverTime[1]
      )
    };
  }

  function getAvailableDeliveries(nowEpoch, limit) {
    var cycle = weeklyCycleAt(nowEpoch);
    if (cycle) {
      var now = partsAt(nowEpoch);
      var todayISO = [
        now.year,
        pad(now.month),
        pad(now.day)
      ].join('-');
      var rolloverWeekday = weeklyRollover.weekday;
      var result = [];

      rules.forEach(function (rule) {
        var daysAfterRollover = typeof rule.cycleOffsetDays === 'number'
          ? rule.cycleOffsetDays
          : (rule.weekday - rolloverWeekday + 7) % 7;
        if (daysAfterRollover === 0) daysAfterRollover = 7;

        var iso = shiftISO(cycle.startISO, daysAfterRollover);
        if (iso < todayISO) return;

        var exception = exceptionFor(iso);
        if (exception && exception.status === 'closed') return;
        var deliveryCutoff = cutoffEpoch(iso, rule, exception);
        if (nowEpoch >= deliveryCutoff) return;

        result.push({
          date: iso,
          weekday: rule.weekday,
          cutoffEpoch: deliveryCutoff,
          slots: exception && Array.isArray(exception.slots) ? exception.slots : rule.slots,
          message: exception && exception.message ? exception.message : ''
        });
      });

      result.sort(function (a, b) { return a.date.localeCompare(b.date); });
      return result.slice(0, limit || rules.length);
    }

    var fallbackNow = partsAt(nowEpoch);
    var start = new Date(Date.UTC(fallbackNow.year, fallbackNow.month - 1, fallbackNow.day));
    var fallbackResult = [];
    for (var offset = 0; offset <= 28 && fallbackResult.length < (limit || 4); offset += 1) {
      var candidate = new Date(start);
      candidate.setUTCDate(start.getUTCDate() + offset);
      var candidateISO = isoFromUTCDate(candidate);
      var candidateRule = ruleForWeekday(candidate.getUTCDay());
      if (!candidateRule) continue;
      var candidateException = exceptionFor(candidateISO);
      if (candidateException && candidateException.status === 'closed') continue;
      var candidateCutoff = cutoffEpoch(candidateISO, candidateRule, candidateException);
      if (nowEpoch >= candidateCutoff) continue;
      fallbackResult.push({
        date: candidateISO,
        weekday: candidate.getUTCDay(),
        cutoffEpoch: candidateCutoff,
        slots: candidateException && Array.isArray(candidateException.slots) ? candidateException.slots : candidateRule.slots,
        message: candidateException && candidateException.message ? candidateException.message : ''
      });
    }
    return fallbackResult;
  }

  function getMostRecentlyClosed(nowEpoch) {
    var cycle = weeklyCycleAt(nowEpoch);
    if (cycle) {
      if (nowEpoch - cycle.startEpoch < 86400000) {
        return { date: cycle.startISO, cutoffEpoch: cycle.startEpoch };
      }
      return null;
    }

    var now = partsAt(nowEpoch);
    var start = new Date(Date.UTC(now.year, now.month - 1, now.day));
    var closed = null;
    for (var offset = 0; offset <= 7; offset += 1) {
      var candidate = new Date(start);
      candidate.setUTCDate(start.getUTCDate() + offset);
      var iso = isoFromUTCDate(candidate);
      var rule = ruleForWeekday(candidate.getUTCDay());
      if (!rule) continue;
      var exception = exceptionFor(iso);
      if (exception && exception.status === 'closed') continue;
      var cutoff = cutoffEpoch(iso, rule, exception);
      if (nowEpoch >= cutoff && (!closed || cutoff > closed.cutoffEpoch)) {
        closed = { date: iso, cutoffEpoch: cutoff };
      }
    }
    return closed;
  }

  function getUpcomingClosure(nowEpoch, beforeDate) {
    var now = partsAt(nowEpoch);
    var start = new Date(Date.UTC(now.year, now.month - 1, now.day));
    for (var offset = 0; offset <= 14; offset += 1) {
      var candidate = new Date(start);
      candidate.setUTCDate(start.getUTCDate() + offset);
      var iso = isoFromUTCDate(candidate);
      if (beforeDate && iso >= beforeDate) return null;
      var exception = exceptionFor(iso);
      if (ruleForWeekday(candidate.getUTCDay()) && exception && exception.status === 'closed') {
        return { date: iso, message: exception.message || '' };
      }
    }
    return null;
  }

  function formatDate(iso) {
    var p = datePartsFromISO(iso);
    return new Intl.DateTimeFormat(locale, {
      timeZone: 'UTC', weekday: 'long', day: 'numeric', month: 'short'
    }).format(new Date(Date.UTC(p.year, p.month - 1, p.day)));
  }

  function formatWeekday(iso) {
    var p = datePartsFromISO(iso);
    return new Intl.DateTimeFormat(locale, { timeZone: 'UTC', weekday: 'long' })
      .format(new Date(Date.UTC(p.year, p.month - 1, p.day)));
  }

  function formatCutoff(epoch) {
    return new Intl.DateTimeFormat(locale, {
      timeZone: timezone, weekday: 'long', hour: 'numeric', minute: '2-digit'
    }).format(new Date(epoch));
  }

  function formatCutoffDay(epoch) {
    return new Intl.DateTimeFormat(locale, { timeZone: timezone, weekday: 'long' }).format(new Date(epoch));
  }

  function formatCutoffTime(epoch) {
    return new Intl.DateTimeFormat(locale, {
      timeZone: timezone, hour: 'numeric', minute: '2-digit'
    }).format(new Date(epoch));
  }

  function replace(template, values) {
    return Object.keys(values).reduce(function (text, key) {
      return text.split('__' + key + '__').join(values[key]);
    }, template || '');
  }

  function renderCountdowns() {
    if (!global.document) return;
    var now = Date.now();
    var next = getAvailableDeliveries(now, 1)[0];
    global.document.querySelectorAll('[data-fi-delivery-countdown]').forEach(function (root) {
      var outcome = root.querySelector('[data-fi-countdown-outcome]');
      var cutoff = root.querySelector('[data-fi-countdown-cutoff]');
      var remaining = root.querySelector('[data-fi-countdown-remaining]');
      var message = root.querySelector('[data-fi-countdown-message]');
      if (!next) {
        if (outcome) outcome.textContent = strings.configurationError || '';
        if (cutoff) cutoff.textContent = '';
        if (remaining) remaining.textContent = '';
        if (message) message.hidden = true;
        return;
      }
      var nextDay = formatWeekday(next.date);
      if (outcome) outcome.textContent = replace(strings.orderFor, { DAY: nextDay });
      if (cutoff) cutoff.textContent = replace(strings.closes, {
        DAY: formatCutoffDay(next.cutoffEpoch),
        TIME: formatCutoffTime(next.cutoffEpoch)
      });
      var diff = Math.max(0, next.cutoffEpoch - now);
      var days = Math.floor(diff / 86400000);
      var hours = Math.floor((diff % 86400000) / 3600000);
      var minutes = Math.floor((diff % 3600000) / 60000);
      var seconds = Math.floor((diff % 60000) / 1000);
      if (remaining) {
        var useArabicDigits = remaining.dataset.useArabicDigits === 'true';
        var formatNumber = function (value) {
          if (!useArabicDigits) return String(value);
          return String(value).replace(/[0-9]/g, function (digit) {
            return '٠١٢٣٤٥٦٧٨٩'[Number(digit)];
          });
        };
        remaining.textContent =
          formatNumber(days) + (remaining.dataset.daysUnit || 'd') + ' ' +
          formatNumber(hours) + (remaining.dataset.hoursUnit || 'h') + ' ' +
          formatNumber(minutes) + (remaining.dataset.minutesUnit || 'm') + ' ' +
          formatNumber(seconds) + (remaining.dataset.secondsUnit || 's');
      }
      var messageText = next.message;
      if (message) {
        message.textContent = messageText || '';
        message.hidden = !messageText;
      }
    });
  }

  global.FiAklaDeliverySchedule = {
    config: config,
    getAvailableDeliveries: getAvailableDeliveries,
    getUpcomingClosure: getUpcomingClosure,
    formatDate: formatDate,
    formatWeekday: formatWeekday,
    formatCutoff: formatCutoff,
    renderCountdowns: renderCountdowns
  };

  if (global.document) {
    if (global.document.readyState === 'loading') {
      global.document.addEventListener('DOMContentLoaded', renderCountdowns, { once: true });
    } else {
      renderCountdowns();
    }
    global.setInterval(renderCountdowns, 1000);
  }
})(typeof window !== 'undefined' ? window : globalThis);
